<template>
  <vl-properties-list v-vl-spacer:bottom.small>
    <vl-properties-label>{{ $t('codeListAttributeMapping.detail.code') }}</vl-properties-label>
    <vl-properties-data>{{ getAttributeLabel('Code') }}</vl-properties-data>
    <vl-properties-label>{{ $t('codeListAttributeMapping.detail.name') }}</vl-properties-label>
    <vl-properties-data>{{ getAttributeLabel('Name') }}</vl-properties-data>
    <vl-properties-label>{{ $t('codeListAttributeMapping.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ getAttributeLabel('Description') }}</vl-properties-data>
  </vl-properties-list>
</template>
<script lang="ts" setup>
import { CodeListAttributeMappingDto } from '@/api/backoffice/clients';

const props = defineProps<{
  detail: CodeListAttributeMappingDto;
}>();

const getAttributeLabel = (key): string => {
  const entityAttribute = props.detail?.attributeMappings?.[key];
  if (entityAttribute) {
    return `${entityAttribute.code}`;
  }
  return '-';
};
</script>
